import {Component, Input, OnInit} from '@angular/core';
import {PhotoViewer} from "@awesome-cordova-plugins/photo-viewer/ngx";
import {MainService} from "../../../services/MainService";

@Component({
    selector: 'images-slider',
    templateUrl: './images-slider.component.html',
    styleUrls: ['./images-slider.component.scss'],
})
export class ImagesSliderComponent implements OnInit {
    @Input()
    public images: Array<any> = [];

    @Input()
    public height: number = 200;

    @Input()
    public autoplay: boolean = true;

    public ready: boolean = false;

    @Input()
    public style: object = {};

    public options: object;

    public videotypes: string = '.mp4';

    public imgagesurls = [];

    constructor(private photoViewer: PhotoViewer, public mainService: MainService) {
    }

    ngOnInit() {
        this.style['max-height'] = this.height + 'px';
        this.style['background-size'] = 'contain';

        for (let k in this.images) {
            this.imgagesurls.push(this.images[k].data['imagefullurl']);
        }

        //console.logthis.imgagesurls)

        this.autoplay = this.mainService.sliderAutoPlay;

        this.options = {'autoplay': this.autoplay};

        this.ready = true;
    }

    showImage(image) {
        this.photoViewer.show(image);
    }


    // playVideo(image)
    // {
    //     this.videoPlayer.play(image).then(() => {
    //      //console.log'video completed');
    //     }).catch(err => {
    //      //console.logerr);
    //     });
    // }

}
